import { getCodetableId } from 'app/area/shared/codetable/breadcrumbs';
import { connectType } from 'app/area/shared/codetable/constants';
import { routeConstants } from 'app/routes/route-constants';

enum CustomCodeSelectorId {
  indicatorFactors = 344,
  linkCodesToUserGroups = 10009
}

const resolvers = {
  [CustomCodeSelectorId.indicatorFactors]: routeConstants.indicatorFactorsAdministrationFor,
  [CustomCodeSelectorId.linkCodesToUserGroups]: routeConstants.codetableLinkCodesFor,
  ...(Object.keys(connectType).reduce((result, key) => ({
    ...result,
    [key]: routeConstants.codetableLinkCodesFor
  }), []))
} as const;

export const getResolver = (breadcrumbs: number[]): { (breadcrumbs: number[]): string } =>
  resolvers[getCodetableId(breadcrumbs)];
